import { Box, Button, NativeSelect, Spacer, Stack, Text } from '@chakra-ui/react';
import type { ChangeEvent, ReactNode } from 'react';
import { FiBook } from 'react-icons/fi';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

type PickerRowProps = {
    children: ReactNode;
    collapsible?: boolean;
    isCollapsed?: boolean;
    onToggleCollapse?: () => void;
};

export function PickerRow({
    children,
    collapsible = false,
    isCollapsed = false,
    onToggleCollapse,
}: PickerRowProps) {
    const isHiddenOnMobile = collapsible && isCollapsed;

    return (
        <Stack gap={3} pt={0}>
            {collapsible && (
                <Button
                    display={{ base: 'inline-flex', md: 'none' }}
                    size="sm"
                    w="full"
                    variant={isCollapsed ? 'outline' : 'subtle'}
                    onClick={onToggleCollapse}
                    alignSelf="flex-start"
                    fontWeight="bold"
                    colorPalette='grey'
                    justifyContent="start"
                >
                    <FiBook />Zmień przedmiot<Spacer />{isCollapsed ? <FiChevronDown /> : <FiChevronUp />}
                </Button>
            )}
            <Stack
                gap={3}
                px={{ base: 0, md: 2 }}
                direction={{ base: 'column', md: 'row' }}
                justify="space-between"
                align="stretch"
                display={isHiddenOnMobile ? { base: 'none', md: 'flex' } : { base: 'flex', md: 'flex' }}
            >
                {children}
            </Stack>
        </Stack>
    );
}

type PickerFieldProps = {
    label: string;
    value: string;
    invalid?: boolean;
    disabled?: boolean;
    placeholder?: string;
    onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
    children: ReactNode;
};

export function PickerField({
    label,
    value,
    invalid = false,
    disabled = false,
    placeholder,
    onChange,
    children,
}: PickerFieldProps) {
    return (
        <Box flex={1} minW={0}>
            <Text fontSize="sm" fontWeight="semibold" color="orange.400" mb={1}>
                {label}
            </Text>
            <NativeSelect.Root variant={disabled ? 'subtle' : 'outline'} invalid={invalid} width="100%" disabled={disabled}>
                <NativeSelect.Field value={value} placeholder={disabled ? ' ' : '-'} onChange={onChange}>
                    {children}
                </NativeSelect.Field>
                <NativeSelect.Indicator />
            </NativeSelect.Root>
        </Box>
    );
}

export function PickerEmptyState({ count = 2 }: { count?: number }) {
    const noun = count === 1 ? 'pole' : 'pola';

    return (
        <Text fontStyle="italic" color="gray.600" py={4}>
            Wypełnij {noun} powyżej, aby zobaczyć dostępne terminy
        </Text>
    );
}
